import React, { useState, useEffect } from "react";

const Footer = () => {
  const [company, setCompany] = useState();

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = () => {
    var company = JSON.parse(localStorage.getItem("company"));

    if (company) {
      setCompany(company);
    }
  };

  return (
    <div>
      <footer className="main-footer">
        <strong>{company && company.footer_text}</strong>
      </footer>
    </div>
  );
};

export default Footer;
